(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ludus-product-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ludus-shipping-progress')) {
    customElements.define('ludus-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold) * (window.Shopify?.currency?.rate || 1);
        this.onCartChange = event => {
          const cart = event.detail?.cart;
          if (!Array.isArray(cart?.items)) return;
          const subtotal = cart.items.reduce((sum, item) => sum + (item.requires_shipping ? item.final_line_price : 0), 0);
          const discounts = (cart.cart_level_discount_applications || []).reduce((sum, discount) => sum + Number(discount.total_allocated_amount ?? discount.discount_application?.total_allocated_amount ?? 0), 0);
          this.update(Math.max(0, subtotal - discounts));
        };
        document.addEventListener('cart:change', this.onCartChange);
        this.update(Number(this.dataset.total));
      }
      disconnectedCallback() {
        document.removeEventListener('cart:change', this.onCartChange);
      }
      update(total) {
        const remaining = Math.max(0, this.threshold - total);
        const currency = this.dataset.currency || 'ISK';
        const isIcelandicKrona = this.dataset.locale === 'is' && currency === 'ISK';
        const amount = isIcelandicKrona
          ? Math.ceil(remaining / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr'
          : new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency }).format(remaining / 100);
        const message = this.querySelector('span');
        if (remaining > 0) {
          const parts = this.dataset.unreached.split('[amount]');
          const amountNode = document.createElement('strong');
          amountNode.textContent = amount;
          message.replaceChildren(parts[0], amountNode, parts[1] || '');
        } else {
          message.textContent = this.dataset.reached;
        }
        const progress = this.querySelector('progress');
        progress.max = this.threshold;
        progress.value = Math.min(this.threshold, Math.max(0, total));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
